<style lang="less">
@import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" >
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit" :loading="loading"></login-form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
export default {
  components: {
    LoginForm
  },
  data(){
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit({ deviceId, userName, password }) {
      this.loading = true
      this.handleLogin({ deviceId, userName, password }).then(res => {
        // this.getUserInfo().then(res => {
        //   this.$router.push({
        //     name: this.$config.homeName
        //   })
        // })
        this.$router.push({
          name: this.$config.homeName
        })
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style></style>
